import { useEffect, useRef, useState } from "react";
import { tileUrl, blankOnError } from "../lib/api";

const RETRY_MS = [2000, 5000, 12000, 30000];

// A duck's signed owner tile (a plain <img>, cached for a year per duck version). While the background is still making
// it the server answers a tiny placeholder or the public 128 px tile, so the picture retries until the real size arrives.
export const TileImg = ({ tile, size = "256", px, alt = "duck", className = "", testId }) => {
  const [attempt, setAttempt] = useState(0);
  const timer = useRef(null);
  const base = tileUrl(tile, size);

  useEffect(() => {
    setAttempt(0);
    return () => clearTimeout(timer.current);
  }, [base]);

  const onLoad = (e) => {
    const { naturalWidth: w, naturalHeight: h } = e.currentTarget;
    if (!tile || tile.ready || Math.max(w, h) >= Number(size) || attempt >= RETRY_MS.length) return;
    timer.current = setTimeout(() => setAttempt((n) => n + 1), RETRY_MS[attempt]);
  };

  return (
    <img
      src={attempt ? `${base}&r=${attempt}` : base}
      alt={alt}
      width={px}
      height={px}
      loading="lazy"
      decoding="async"
      onLoad={onLoad}
      onError={blankOnError}
      data-testid={testId}
      className={className}
    />
  );
};
